import { Box, styled } from '@mui/material';

// Card único del auth (referencia: rail + hero central + zona de formularios).
// En xs se apila (hero compacto arriba); en md+ es una fila con altura fija para
// que los formularios deslicen dentro (scroll interno, no de página).
const StyledAuthCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.surface.content,
  border: `1px solid ${theme.palette.hairline.main}`,
  borderRadius: '24px',
  boxShadow: theme.palette.shadow.card,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  width: 'min(1000px, 100%)',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    height: 'clamp(560px, calc(100dvh - 96px), 720px)'
  }
}));

export default StyledAuthCard;
